
document.addEventListener('DOMContentLoaded', function()
{
    // Wait for images and CSS to load before initializing sliders
    window.addEventListener('load', function() {
        setTimeout( function() {
            createSlickSliders();
            console.log('Sliders created');
        }, 100 );
    });
});

// Creates Slick slider instances for the page
function createSlickSliders()
{
    // Home Page Spotlight
    var spotlightSlider = jQuery('.spotlight.slider').slick({
        fade: true,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 10000
    });
    //department slider
    var departmentSlider = jQuery('.department-slider').slick({
        fade: true,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 10000
    });

    // Client Logos
    var clientSlider = jQuery('.client-slider').slick({
        dots: false,
        arrows: false,
        infinite: true,
        centerMode: true,
        slidesToShow: 5,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 960,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1
              }
            }
        ]
    });
  
    // Testimonials
    var testimonialsSlider = jQuery('.testimonials').slick({
        dots: false,
        arrows: true,
        fade: true,
        infinite: true,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        nextArrow: '<a href="javascript:void(0);" class="t-arrow tollers-next"><span class="fas fa-chevron-right" aria-hidden="true"></span></a>',
        prevArrow: '<a href="javascript:void(0);" class="t-arrow tollers-prev"><span class="fas fa-chevron-left" aria-hidden="true"></span></a>'
    });

    // Our Experts
    var expertsSlider = jQuery('.experts-inner').slick({
        dots: false,
        arrows: false,
        fade: true,
        infinite: true,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        adaptiveHeight: true,
        nextArrow: '<a href="javascript:void(0);" class="t-arrow tollers-next">More<span class="fas fa-chevron-right" aria-hidden="true"></span></a>',
        prevArrow: '<a href="javascript:void(0);" class="t-arrow tollers-prev"><span class="fas fa-chevron-left" aria-hidden="true"></span>More</a>'
    });

    var teamSlider = jQuery('.team-slider').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
    });

    var expertsSliderBuilder = jQuery('.experts-slider').slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        autoplay: true,
        autoplaySpeed: 5000,
        adaptiveHeight: true,
        nextArrow: '<a href="javascript:void(0);" class="t-arrow tollers-next">More<span class="fas fa-chevron-right" aria-hidden="true"></span></a>',
        prevArrow: '<a href="javascript:void(0);" class="t-arrow tollers-prev"><span class="fas fa-chevron-left" aria-hidden="true"></span>More</a>',
        responsive: [
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 960,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 680,
              settings: {
                slidesToShow: 1
              }
            }
        ]
    });

    // Fix for width issues - force resize after initialization
    setTimeout(function() {
        if (spotlightSlider) {
            spotlightSlider.slick('refresh');
            console.log('Spotlight Slider Refreshed');
        }
        if (departmentSlider) {
            departmentSlider.slick('refresh');
            console.log('Department Slider Refreshed');
        }
        if (clientSlider) {
            clientSlider.slick('refresh');
            console.log('Client Slider Refreshed');
        }
        if (testimonialsSlider) {
            testimonialsSlider.slick('refresh');
            console.log('Testimonials Slider Refreshed');
        }
        if (expertsSlider) {
            expertsSlider.slick('refresh');
            console.log('Expert Slider Refreshed');
        }
        if (teamSlider) {
            teamSlider.slick('refresh');    
            console.log('Team Slider Refreshed');
        }
        if (expertsSliderBuilder) {
            expertsSliderBuilder.slick('refresh');
            console.log('Expert Slider Builder Refreshed');
        }
    }, 100);
}

jQuery('.experts-slider').on('click', '.expert', function()
{
    // Change the current slide on the main expert slider to the index of this one
    jQuery('.experts-inner').slick('slickGoTo', jQuery(this).data('slick-index'));
});